<app-card-header-loader *ngIf="isLoading | async; else detailView" />

<ng-template #detailView>
  <app-card *ngIf="detail | async as detail" [cardClasses]="'mb-8'">
    <ng-container cardBody>
      <div class="card-title">
        <div class="d-flex align-items-center mb-3">
          <h2 class="mb-0 me-4">{{ detail.code }}</h2>
          <span class="badge badge__status {{ 'badge__status--' + detail.status_enum }}">{{ detail.status_string }}</span>
          <div [innerHTML]="renderStatusBadge()"></div>
        </div>
      </div>

      <app-text-copy-clipboard *ngIf="showCopyClipboard()" [popoverText]="'Id ERP berhasil di copy'" [text]="getCopyClipboardText()" [valueToCopy]="getCopyClipboardValue()" />

      <app-text-copy-clipboard *ngIf="hasTagCode()" [popoverText]="'Tag code berhasil di copy'" [text]="getCopyClipboardText(true)" [valueToCopy]="getCopyClipboardValue(true)" />

      <div class="me-4" *ngIf="detail?.area">Cabang: {{ detail.area }}</div>
      <div class="me-4" *ngIf="detail.warehouse_name && detail.warehouse_address">Gudang Pengirim: {{ detail.warehouse_name + ', ' + detail.warehouse_address }}</div>

      <div *ngIf="detail.note_view_info" class="mt-6">
        <app-note-view [color]="'info'" [text]="detail.note_view_info" [icon]="ASSETS_ICON.IC_INFORMATION"></app-note-view>
      </div>

      <hr />

      <div class="d-flex w-100 gap-3">
        <div [class]="detail.changes.length <= 4 ? (detail.changes.length === 3 ? 'w-33' : 'w-25') : 'w-20'" *ngFor="let item of detail.changes">
          <div class="font-12 fw-semibold text-gray-500 mb-2">{{ item.title }}</div>
          <p *ngIf="item.actor" class="mb-0 font-14 fw-bold text-gray-800">{{ item.actor }}</p>
          <p class="font-14 fw-bold text-gray-800">
            {{ generateDate(item.date) }}
          </p>
          <ng-container *ngIf="item.document">
            <app-image
              [ctaLabelClass]="'fw-bold text-info cursor-pointer'"
              [ctaLabel]="'Lihat Dokumen Approval'"
              [modalOptions]="{ size: 'md' }"
              [src]="item.document"
              [useImagePreview]="false"
            ></app-image>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </app-card>
</ng-template>
